import { FILTER_REQUEST, FILTER_REQUEST_API_ERROR, FILTER_REQUEST_SUCCESS } from "./ActionTypes";
  
  const initialState = {
    error: "",
    loading: false,
  };
  
  const FilterSection = (state = initialState, action) => {
    switch (action.type) {
      case FILTER_REQUEST:
        state = {
          ...state,
          loading: true,
        };
        break;
        case FILTER_REQUEST_SUCCESS:
        state = {
          ...state,
          filterResponseData:action.payload.data,
          loading: false,
        };
        break;
      case FILTER_REQUEST_API_ERROR:
        state = {
          ...state,
          error: action.payload.data,
          loading: false,
          isUserLogout: false,
        };
        break;

      default:
        state = { ...state };
        break;
    }
    return state;
  };
  
  export default FilterSection;
  